/**
 * ScanHistoryButton — FE #124.5 (Surface C).
 *
 * Top-bar 🕒 history icon, always visible across every tab next to
 * the NotificationBell. Tap → ScanHistory route at /scans.
 *
 * Design choice (locked 2026-05-27): no badge. The Dashboard recovery
 * banner (FE #124.4) already surfaces unfinished-scan urgency
 * prominently — the top-bar icon is just the discovery affordance
 * ("you can always reach your scan history from here"), not an
 * urgency surface. Keeping it badgeless avoids competing with the
 * notification bell's count + matches the iOS Photos / Files
 * history-icon convention.
 *
 * Mounted in DashboardScreen, BrowseScreen, ShareFlowScreen, and
 * CrewHubScreen — wherever NotificationBell appears.
 */

import React from 'react';
import { TouchableOpacity } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import { fpColors } from '../../../styles/theme';

interface ScanHistoryButtonProps {
  onPress: () => void;
  accessibilityLabel?: string;
}

export const ScanHistoryButton: React.FC<ScanHistoryButtonProps> = ({
  onPress,
  accessibilityLabel,
}) => {
  return (
    <TouchableOpacity
      onPress={onPress}
      accessibilityLabel={accessibilityLabel ?? 'Open scan history'}
      accessibilityRole="button"
      testID="scan-history-button"
      hitSlop={8}
      style={{
        width: 36,
        height: 36,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: 18,
      }}
    >
      {/* `history` — Material's clock-rewind icon, semantically
          "history of past events." Filled style (no -outline suffix)
          matches Material's default icon set the rest of the top-bar
          uses. */}
      <MaterialIcons
        name="history"
        size={24}
        color={fpColors.onSurface}
      />
    </TouchableOpacity>
  );
};
